import { Component, Inject, InjectionToken, HostListener } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';
import { Announcement } from './announcement';

export const ANNOUNCEMENT_TOKEN = new InjectionToken('AnnouncementItem');

@Component({
    selector: 'announcement-dialog',
    template: require('./announcement-dialog.component.html'),
    styles: [require('./announcement-dialog.component.scss')]
})
export class AnnouncementDialogComponent {
    public announcement: Announcement;

    constructor(
        private dialog: MdlDialogReference,
        @Inject(ANNOUNCEMENT_TOKEN) announcement: Announcement
    ) {
        this.announcement = announcement;
    }

    @HostListener('document:keydown.esc')
    public close() {
        this.dialog.hide();
    }
}